import i18next from "i18next";

export const SUPPORTED_LANGS = ["en", "zh"] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];

export const LANG_NAMES: Record<Lang, string> = {
	en: "English",
	zh: "中文",
};

let initialized = false;

export const initI18n = async (lang: string) => {
	if (initialized) {
		return;
	}
	initialized = true;

	const [enCols, zhCols, enUi, zhUi, enSettings, zhSettings] =
		await Promise.all([
			import("../../locales/en/cols.json"),
			import("../../locales/zh/cols.json"),
			import("../../locales/en/ui.json"),
			import("../../locales/zh/ui.json"),
			import("../../locales/en/settings.json"),
			import("../../locales/zh/settings.json"),
		]);

	await i18next.init({
		lng: SUPPORTED_LANGS.includes(lang as Lang) ? lang : "en",
		fallbackLng: "en",
		ns: ["cols", "ui", "settings"],
		defaultNS: "ui",
		resources: {
			en: {
				cols: enCols,
				ui: enUi,
				settings: enSettings,
			},
			zh: {
				cols: zhCols,
				ui: zhUi,
				settings: zhSettings,
			},
		},
		interpolation: {
			escapeValue: false,
		},
	});
};

export const setLanguage = async (lang: Lang) => {
	await i18next.changeLanguage(lang);
};

export default i18next;
